import Color from './Color.js';
import { version } from './version.js';

const chroma = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new Color(...args);
};

chroma.version = version;
export default chroma;